import {Routes} from '@angular/router';
import {AuthGuard, LoginGuard} from './shared/guard';
import {environment} from 'environments/environment';

export const AppRoutes: Routes = [
    {path: '', loadChildren: './app-starter/app-starter.module#AppStarterModule', canActivate: [LoginGuard]},
    {path: environment.baseAppPath, loadChildren: './app-body/app-body.module#AppBodyModule', canActivate: [AuthGuard]},
];
